/* Highlighting item in table of contents when section is active on page as scrolling */
const isElementInViewport = (element) => {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const initActiveHeadingWhenScrolling = () => {
  const scrollLinks = document.querySelectorAll('#c-1685513548622 [data-label="Row"] a, #table-of-content ul li a');
  let activeLink = null;
  window.addEventListener('scroll', () => {
    scrollLinks.forEach(link => {
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      if (isElementInViewport(targetElement)) {
        activeLink = link;
      }
    });
    scrollLinks.forEach(link => {
      link.classList.remove('active');
    });

    if (activeLink) {
      activeLink.classList.add('active');
    }
  });
}

window.initActiveHeadingWhenScrolling = initActiveHeadingWhenScrolling;

/* Article Scroll Indicator */
const initScrollIndicator = () => {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  if (document.getElementById("progress-bar")) {
    document.getElementById("progress-bar").style.width = scrolled + "%";
  }
}

const initSlider = () => {
  const sliders = document.querySelectorAll('.data-slider:not(.flickity-enabled)');

  if (sliders.length == 0) return;

  sliders.forEach(slider => {
    const prevNext = slider.getAttribute('data-prevnext') === 'true';
    const groupCellsAttr = slider.getAttribute('data-groupcells');
    const adaptiveHeight = slider.getAttribute('data-adaptiveHeight') === 'true';
    let autoplay = slider.getAttribute('data-autoplay') === 'true';
    const autospeed = slider.getAttribute('data-autospeed');
    
    if (autoplay) {
      autoplay = autospeed ? parseInt(autospeed) : 3000;
    }

    const fadetransition = slider.getAttribute('data-fadetransition') === 'true';
    const loop = slider.getAttribute('data-loop') === 'true';

    const getGroupCells = () => {
      return window.innerWidth <= 990 ? 1 : parseInt(groupCellsAttr) || 1;
    };

    const flkty = new Flickity(slider, {
      cellAlign: 'left',
      prevNextButtons: prevNext,
      wrapAround: loop,
      groupCells: getGroupCells(),
      adaptiveHeight: adaptiveHeight,
      autoPlay: autoplay,
      pauseAutoPlayOnHover: false,
      contain: true,
      percentPosition: true,
      fade: fadetransition,
      imagesLoaded: true,
      lazyLoad: true,
      on: {
        change: function (index) {
          var elements = slider.querySelectorAll('.banner__image');
          elements.forEach(function (element) {
            element.classList.add('animate--slide-in');
          });
        },
        settle: function (index) {
          var elements = slider.querySelectorAll('.banner__image');
          elements.forEach(function (element) {
            element.classList.remove('animate--slide-in');
          });
        }
      }
    });

    // Handle resize properly
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const newGroupCells = getGroupCells();
        if (flkty.options.groupCells !== newGroupCells) {
          flkty.options.groupCells = newGroupCells;
        }
        flkty.resize();
      }, 200);
    };

    window.addEventListener('resize', handleResize);
    
    // Clean up on destroy (optional but good practice)
    slider.addEventListener('destroy.flickity', () => {
      window.removeEventListener('resize', handleResize);
    });
  });
}

// Add support for Shopify Theme Editor
document.addEventListener('shopify:section:load', () => {
  initSlider();
});

const initPartnerList = () => {
  const partnerContainer = document.getElementById("partner-container");
  const mainPartnerList = document.querySelectorAll(".partner-list")[0]; // Lấy partner-list của section đầu tiên
  const loadMoreButton = document.getElementById("load-more");
  const partnerCountElem = document.getElementById("partner-count");
  const partnerTotalElem = document.getElementById("partner-total");

  const partnerLimit = parseInt(partnerContainer.getAttribute('data-limit'), 10);
  const partnerIncrease = parseInt(partnerContainer.getAttribute('data-increase'), 10);
  let currentPage = 1;

  const radios = document.querySelectorAll('input[type="radio"][name="radio"]');
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  const partners = Array.from(document.querySelectorAll('.partner-item'));

  let filteredPartners = [];

  /* merge all partner-item to one list */
  const allPartnerSections = document.querySelectorAll(".partner-list");

  allPartnerSections.forEach((section, index) => {
    if (index === 0) return;
    const partnerItems = Array.from(section.querySelectorAll('.partner-item'));

    partnerItems.forEach(partner => {
      mainPartnerList.appendChild(partner);
    });

    const additionalLoadMoreButton = section.querySelector('.load-more');
    if (additionalLoadMoreButton) {
      additionalLoadMoreButton.style.display = "none";
    }

    filteredPartners = filteredPartners.concat(partnerItems);
  });

  filteredPartners = Array.from(mainPartnerList.querySelectorAll('.partner-item')).concat(filteredPartners);

  const totalPartners = filteredPartners.length;
  partnerTotalElem.innerHTML = totalPartners;

  const handleButtonStatus = () => {
    if (filteredPartners.length <= currentPage * partnerIncrease || currentPage * partnerIncrease >= partnerLimit) {
      loadMoreButton.style.display = "none";
      document.getElementById("load-more").classList.add("loading");
    } else {
      document.getElementById("load-more").classList.remove("loading");
      loadMoreButton.style.display = "block";
      loadMoreButton.removeAttribute('disabled');
      loadMoreButton.querySelector('.load-more_text').style.display = 'block';
      loadMoreButton.querySelector('.load-more_spinner').style.display = 'none';
    }
  };

  const addPartners = (pageIndex) => {
    loadMoreButton.setAttribute('disabled', true);
    loadMoreButton.querySelector('.load-more_text').style.display = 'none';
    loadMoreButton.querySelector('.load-more_spinner').style.display = 'block';
    currentPage = pageIndex;

    setTimeout(() => {
      const startRange = (pageIndex - 1) * partnerIncrease;
      const endRange = Math.min(pageIndex * partnerIncrease, partnerLimit, filteredPartners.length);

      for (let i = startRange; i < endRange; i++) {
        filteredPartners[i].style.display = "block";
      }

      partnerCountElem.innerHTML = endRange;

      handleButtonStatus();
    }, 500);
  };

  function getAttrArray(el, attr) {
    return (el.getAttribute(attr) || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }

  function filterPartners() {
    document.getElementById("load-more").classList.add("loading");
    const selectedAgency = document.querySelector('input[type="radio"][name="radio"]:checked');
    const selectedRegions = Array.from(document.querySelectorAll('.option-list__1 input[type="checkbox"]:checked')).map(checkbox => checkbox.parentNode.parentNode.dataset.option);
    const selectedServices = Array.from(document.querySelectorAll('.option-list__2 input[type="checkbox"]:checked')).map(checkbox => checkbox.parentNode.parentNode.dataset.option);
    const selectedOption3 = Array.from(document.querySelectorAll('.option-list__3 input[type="checkbox"]:checked')).map(checkbox => checkbox.parentNode.parentNode.dataset.option);

    filteredPartners = partners.filter(partner => {
      const agencyType = partner.getAttribute('data-agency-type');
      // const partnerRegions = partner.getAttribute('data-region').split(',');
      // const partnerServices = partner.getAttribute('data-services').split(',');
      // const partnerOption3 = partner.getAttribute('data-option3').split(',');

      const partnerRegions = getAttrArray(partner, 'data-region');
      const partnerServices = getAttrArray(partner, 'data-services');
      const partnerOption3 = getAttrArray(partner, 'data-option3');

      const matchesAgency = !selectedAgency || agencyType === selectedAgency.parentNode.parentNode.dataset.option;
      const matchesRegion = selectedRegions.length === 0 || selectedRegions.some(region => partnerRegions.includes(region));
      const matchesService = selectedServices.length === 0 || selectedServices.some(service => partnerServices.includes(service));
      const matchesOption3 = selectedOption3.length === 0 || selectedOption3.some(option3 => partnerOption3.includes(option3));

      return matchesAgency && matchesRegion && matchesService && matchesOption3;
    });

    partners.forEach(partner => {
      if (!filteredPartners.includes(partner)) {
        partner.style.display = "none";
      }
    });

    partnerTotalElem.innerHTML = filteredPartners.length;

    currentPage = 1;
    addPartners(currentPage);

    setTimeout(function () {
      handleButtonStatus();
    }, 1000)
  }

  radios.forEach(radio => {
    radio.addEventListener('change', filterPartners);
  });

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', filterPartners);
  });

  // Initially load only the items up to the data-limit and handle load more button
  filteredPartners = partners;
  addPartners(currentPage);
  handleButtonStatus();

  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
      addPartners(currentPage + 1);
    });
  }
};

const initGetUrlParameter = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const type = urlParams.get('type');
  const regions = urlParams.get('regions');
  const services = urlParams.get('services');

  if (type === 'agency') {
    const agencyOption = document.querySelector('li[data-option="agency"] label.control-radio input');
    if (agencyOption) {
      agencyOption.click();
    }
  } else if (type === 'tech-partner') {
    const techPartnerOption = document.querySelector('li[data-option="tech partner"] label.control-radio input');
    if (techPartnerOption) {
      techPartnerOption.click();
    }
  }

  if (regions) {
    const regionArray = regions.split(',');
    regionArray.forEach(region => {
      const regionOption = document.querySelector(`li[data-option="${region}"] label.control-checkbox input`);
      if (regionOption) {
        regionOption.click();
      }
    });
  }

  if (services) {
    const serviceArray = services.split(',');
    serviceArray.forEach(service => {
      const serviceOption = document.querySelector(`li[data-option="${service}"] label.control-checkbox input`);
      if (serviceOption) {
        serviceOption.click();
      }
    });
  }
}

/*
**
** PARTNER DIRECTORY 2 - START
**
*/

/*
 * The list and the sidebar are two separate sections. In the Theme Editor either one is
 * re-rendered after every setting edit (shopify:section:load), so initPartnerList2 can be
 * called again at any time: it first removes everything the previous call bound, then links
 * the current list and sidebar. Document-level Shopify editor events are registered once in init().
 */
let partnerList2Teardown = null;
let partnerList2Api = null;
let partnerList2Booted = false; // URL deep links are only read on the first init of the page
const isThemeEditor = () => !!(window.Shopify && window.Shopify.designMode);

const teardownPartnerList2 = () => {
  if (partnerList2Teardown) partnerList2Teardown();
  partnerList2Teardown = null;
  partnerList2Api = null;
};

const initPartnerList2 = () => {
  teardownPartnerList2();

  const list = document.querySelector(".partner-list__style_2");
  if (!list) return;
  // "List rows" layout (SEO listicle): compact rows, each with a Details button that opens its description in place (class is-open, independent toggles).
  // No See more / See less and no grid reflow, so none of the card-grid expand code below runs for it.
  const isRowsLayout = list.classList.contains("partner-list__layout_rows");
  function setRowOpen(item, open) {
    item.classList.toggle("is-open", open);
    item.querySelectorAll(".partner-item__toggle").forEach(btn => btn.setAttribute("aria-expanded", open ? "true" : "false"));
  }

  // every listener goes through listen() so teardown can remove it (no double binding after a section reload)
  const cleanups = [];
  const listen = (target, type, handler, options) => {
    target.addEventListener(type, handler, options);
    cleanups.push(() => target.removeEventListener(type, handler, options));
  };
  partnerList2Teardown = () => {
    cleanups.forEach(fn => fn());
    cleanups.length = 0;
  };

  // card picked in the Theme Editor: always stays visible, whatever the filters / paging say
  let selectedItem = null;
  let scrollTimer = null;
  cleanups.push(() => clearTimeout(scrollTimer));

  function scrollToItem(el, offset = 0) {
    const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: y,
      behavior: reduceMotion ? "auto" : "smooth"
    });
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (rect.top >= 0 && rect.bottom <= window.innerHeight);
  }

  // Ghost copies of cards that just left a filter are real children of the list for about 290ms (shared filter motion, assets/qikify-filter-anim.js).
  // Every handler that measures, re-orders or walks the list's children ends that motion first (settleAnimation) and also skips the ghosts.
  const isGhost = (el) => el.hasAttribute("data-qk-filter-ghost");

  function restoreOrder(container) {
    const items = Array.from(container.children).filter((el) => !isGhost(el));
    items
      .sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index))
      .forEach(el => container.appendChild(el));
  }

  /*
   * Open / close animation (style 2). The open card is wider than the compact one (it spans the whole row) and
   * the cards that shared its row move to the next row, so the grid reflows. It is animated, not teleported, with
   * the Web Animations API (300ms, ease-out, no overshoot), measuring before / after instead of hard-coding sizes:
   *  - the card starts as a window the size of its old cell, at the old cell's position, and opens up to the full
   *    panel (clip-path + transform), while its height goes from the old height to the new one (matters most on
   *    phones / tablets, where the open panel is taller than the compact card) and the details fade in;
   *  - the cards the reflow moves slide from where they were to where they are (transform only).
   * "See less" plays it backwards: the panel closes down to a compact-card sized window and the details fade out,
   * then the card goes back to its place in the grid and the cards that moved slide into theirs.
   * Nothing sticks: WAAPI leaves no inline height / transform behind when an animation ends or is cancelled, so a
   * resize while open can never freeze a stale pixel value. Only one card animates at a time and anything that needs
   * a settled DOM (another card opening, a filter change, a Theme Editor reload) calls settleAnimation(), which
   * jumps straight to the end state. prefers-reduced-motion: no animation at all.
   */
  const ANIM_MS = 300;
  const ANIM_EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)"; // ease-out, no overshoot
  const ANIM_PARTS = ".partner-item__popup, .partner-item__actions, .partner-item__less";
  const CARD_RADIUS = 16; // matches the card border radius in section-qikify-partner-list.css
  let activeAnim = null; // { item, finish } while a card is opening or closing
  let activeFlips = [];  // slide animations of the cards moved by the end of a close

  const prefersReducedMotion = () => !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const canAnimate = (el) => typeof el.animate === "function" && !prefersReducedMotion() && el.getClientRects().length > 0;

  function settleAnimation() {
    // first: end a running filter transition (its ghost copies leave the list and its animations are cancelled), so nothing below sees them
    if (window.QikifyFilterAnim) window.QikifyFilterAnim.settle(list);
    if (activeAnim) activeAnim.finish();
    activeFlips.forEach((a) => { try { a.cancel(); } catch (err) { /* already gone */ } });
    activeFlips = [];
  }
  cleanups.push(settleAnimation);

  const visibleCards = () => Array.from(list.children).filter((el) => el.classList.contains("partner-item") && !isGhost(el) && el.getClientRects().length > 0);
  const snapshot = () => new Map(visibleCards().map((el) => [el, el.getBoundingClientRect()]));
  const px = (n) => Math.round(n * 100) / 100 + "px";
  // border-box on purpose: the measured sizes include the card border, a content-box height would end 2px too tall
  const heightFrames = (from, to) => [{ height: px(from), boxSizing: "border-box" }, { height: px(to), boxSizing: "border-box" }];
  const slideFrames = (dx, dy) => [{ transform: "translate(" + px(dx) + ", " + px(dy) + ")" }, { transform: "none" }];
  const windowClip = (right) => "inset(0px " + px(right) + " 0px 0px round " + CARD_RADIUS + "px)";
  const detailsFade = (item, closing) => Array.from(item.querySelectorAll(ANIM_PARTS)).map((el) => ({
    el,
    frames: closing ? [{ opacity: 1 }, { opacity: 0 }] : [{ opacity: 0, transform: "translateY(6px)" }, { opacity: 1, transform: "none" }],
    duration: closing ? 180 : ANIM_MS
  }));

  // specs: [{ el, frames, duration? }]. onEnd(cancelAll) runs when everything has played (or was settled);
  // it may call cancelAll() itself first when it needs to measure the real layout.
  function runAnimation(item, specs, fill, onEnd) {
    const anims = specs.map((sp) => sp.el.animate(sp.frames, { duration: sp.duration || ANIM_MS, easing: ANIM_EASE, fill }));
    const cancelAll = () => anims.forEach((a) => { try { a.cancel(); } catch (err) { /* already gone */ } });
    item.classList.add("is-animating");

    let done = false;
    let safety = null;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(safety);
      activeAnim = null;
      onEnd(cancelAll);
      cancelAll();
      item.classList.remove("is-animating");
    };
    activeAnim = { item, finish };
    safety = setTimeout(finish, ANIM_MS + 80); // never leave a card half-open if a browser drops the finish event
    Promise.all(anims.map((a) => a.finished)).then(finish, () => {});
  }

  // aria-expanded on both toggles ("See more" / "See less") of every card follows the card's is-expanded class
  // (a card that is closing already reports collapsed)
  function syncExpandedAria() {
    list.querySelectorAll(".partner-item").forEach(card => {
      const open = card.classList.contains("is-expanded") && !card.classList.contains("is-collapsing") ? "true" : "false";
      card.querySelectorAll(".partner-item__link_text, .partner-item__less").forEach(btn => btn.setAttribute("aria-expanded", open));
    });
  }

  function playExpand(item, before) {
    const a0 = before.get(item);
    const a1 = item.getBoundingClientRect();
    if (!a0) return;
    const specs = [];
    const heightMoves = Math.abs(a1.height - a0.height) > 1;
    if (heightMoves) specs.push({ el: item, frames: heightFrames(a0.height, a1.height) });
    if (Math.abs(a0.left - a1.left) > 1 || Math.abs(a0.top - a1.top) > 1) specs.push({ el: item, frames: slideFrames(a0.left - a1.left, a0.top - a1.top) });
    if (a1.width - a0.width > 1) specs.push({ el: item, frames: [{ clipPath: windowClip(a1.width - a0.width) }, { clipPath: windowClip(0) }] });
    // the cards the reflow moved: from their old spot to the new one. While this card grows from its old height to its
    // new one the cards below sit (new - (new height - old height)) lower, so the same shift is added to their start.
    let afterItem = false;
    visibleCards().forEach((el) => {
      if (el === item) { afterItem = true; return; }
      const p0 = before.get(el);
      if (!afterItem || !p0) return;
      const p1 = el.getBoundingClientRect();
      const dx = p0.left - p1.left;
      const dy = p0.top - p1.top + (heightMoves ? a1.height - a0.height : 0);
      if (Math.abs(dx) > 1 || Math.abs(dy) > 1) specs.push({ el, frames: slideFrames(dx, dy) });
    });
    detailsFade(item, false).forEach((sp) => specs.push(sp));
    runAnimation(item, specs, "none", () => {});
  }

  function expandItem(item, animate = false, noScroll = false) {
    settleAnimation();
    restoreOrder(list);

    // reset trạng thái
    list.querySelectorAll(".partner-item.is-expanded").forEach(el => el.classList.remove("is-expanded"));

    const doAnimate = animate && canAnimate(item);
    const before = doAnimate ? snapshot() : null; // every card where it is now (compact grid, this card in its own cell)

    const index = Number(item.dataset.index) - 1; // forloop.index là 1-based
    // number of grid columns right now (3 / 2 / 1 depending on screen width)
    const columns = Math.max(1, getComputedStyle(list).gridTemplateColumns.split(' ').length);
    const rowStartIndex = Math.floor(index / columns) * columns;

    // tìm item đầu row theo data-index
    const rowStartItem = list.querySelector(`.partner-item[data-index="${rowStartIndex + 1}"]`);
    if (rowStartItem && item !== rowStartItem) {
      list.insertBefore(item, rowStartItem);
    }

    item.classList.add("is-expanded");
    syncExpandedAria();

    if (doAnimate) playExpand(item, before);

    clearTimeout(scrollTimer);
    if (noScroll) return; // Theme Editor select: the editor scrolls to the block itself; a second smooth scroll from here made the preview jump up and down
    if (doAnimate) {
      // check the final position once the card has grown (not at its starting size)
      scrollTimer = setTimeout(() => {
        if (!isInViewport(item)) requestAnimationFrame(() => scrollToItem(item, 160));
      }, 500);
    } else if (!isInViewport(item)) {
      scrollTimer = setTimeout(() => {
        requestAnimationFrame(() => {
          scrollToItem(item, 160);
        });
      }, 500);
    }
  }

  // The one way a card goes back to its compact state (See less, and the Theme Editor deselect).
  // withFocusAndScroll (See less only): focus goes back to the card's "See more" button, and if the
  // collapsed card is now above the top of the screen it is scrolled back into view (no jump if it is visible).
  function collapseItem(item, withFocusAndScroll = false) {
    settleAnimation();
    item.classList.remove("is-expanded", "is-collapsing");
    restoreOrder(list);
    syncExpandedAria();
    clearTimeout(scrollTimer);

    if (!withFocusAndScroll) return;
    const seeMore = item.querySelector(".partner-item__link_text");
    if (seeMore) seeMore.focus({ preventScroll: true });
    if (item.getBoundingClientRect().top < 0) scrollToItem(item, 160);
  }

  // "See less": the open panel closes down to the size of the compact card while the details fade out, then the card
  // goes back to its place and focus moves to its "See more". The compact size is measured on the real compact layout,
  // so the end state matches the settled one exactly.
  function collapseItemAnimated(item) {
    settleAnimation();
    if (!item.classList.contains("is-expanded") || !canAnimate(item)) {
      collapseItem(item, true);
      return;
    }
    const detailBlocks = Array.from(item.querySelectorAll(".partner-item__popup, .partner-item__actions"));
    const order = Array.from(list.children);
    const scrollY = window.pageYOffset;
    const focused = document.activeElement; // moving cards in the DOM / hiding "See less" below drops focus, so it is put back
    const anchor = list.style.overflowAnchor;
    list.style.overflowAnchor = "none"; // the measuring below must not make the browser adjust the scroll position
    const open = item.getBoundingClientRect();
    item.classList.remove("is-expanded");
    restoreOrder(list);
    const compact = item.getBoundingClientRect();
    item.classList.add("is-expanded");
    order.forEach(el => list.appendChild(el));
    list.style.overflowAnchor = anchor;
    if (window.pageYOffset !== scrollY) window.scrollTo(0, scrollY);
    if (focused && focused !== document.body && document.activeElement !== focused) focused.focus({ preventScroll: true });

    item.classList.add("is-collapsing");
    // no focusable content left behind while it fades out ("See less" keeps focus until the card is closed)
    detailBlocks.forEach(el => el.setAttribute("inert", ""));
    syncExpandedAria();
    clearTimeout(scrollTimer);

    const specs = [];
    if (Math.abs(open.height - compact.height) > 1) specs.push({ el: item, frames: heightFrames(open.height, compact.height) });
    if (open.width - compact.width > 1) specs.push({ el: item, frames: [{ clipPath: windowClip(0) }, { clipPath: windowClip(open.width - compact.width) }] });
    detailsFade(item, true).forEach((sp) => specs.push(sp));

    runAnimation(item, specs, "forwards", (cancelAll) => {
      const pre = snapshot();           // the panel at its smallest, the other cards where the open layout puts them
      cancelAll();
      detailBlocks.forEach(el => el.removeAttribute("inert"));
      const hadFocus = item.contains(document.activeElement) || document.activeElement === document.body || !document.activeElement;
      item.classList.remove("is-expanded", "is-collapsing");
      restoreOrder(list);
      syncExpandedAria();
      // everything the move back put somewhere else slides there instead of jumping
      visibleCards().forEach((el) => {
        const p0 = pre.get(el);
        if (!p0) return;
        const p1 = el.getBoundingClientRect();
        const dx = p0.left - p1.left;
        const dy = p0.top - p1.top;
        if (Math.abs(dx) > 1 || Math.abs(dy) > 1) activeFlips.push(el.animate(slideFrames(dx, dy), { duration: 240, easing: ANIM_EASE }));
      });
      const seeMore = item.querySelector(".partner-item__link_text");
      if (hadFocus && seeMore) seeMore.focus({ preventScroll: true });
      if (item.getBoundingClientRect().top < 0) scrollToItem(item, 160);
    });
  }

  listen(list, "click", (e) => {
    if (isRowsLayout) {
      const rowToggle = e.target.closest(".partner-item__toggle");
      if (rowToggle) {
        const row = rowToggle.closest(".partner-item");
        if (row) setRowOpen(row, !row.classList.contains("is-open"));
      }
      return;
    }
    const less = e.target.closest(".partner-item__less");
    if (less) {
      const openItem = less.closest(".partner-item");
      if (openItem && !openItem.classList.contains("is-collapsing")) collapseItemAnimated(openItem);
      return;
    }

    const btn = e.target.closest(".partner-item__link_text");
    if (!btn) return;

    const item = btn.closest(".partner-item");
    expandItem(item, true);
    // "See more" is hidden once the card is open: hand keyboard focus to "See less" instead of dropping it
    const seeLess = item.querySelector(".partner-item__less");
    if (seeLess) seeLess.focus({ preventScroll: true });
  });

  // Theme Editor: selecting a partner in the left panel shows it and opens its See more panel
  function selectItem(item) {
    selectedItem = item;
    item.style.display = 'flex';
    if (isRowsLayout) { setRowOpen(item, true); return; } // the editor scrolls to the selected block itself
    expandItem(item, false, true);
  }

  function deselectItem(item) {
    if (selectedItem === item) selectedItem = null;
    if (isRowsLayout) { setRowOpen(item, false); return; }
    collapseItem(item);
  }

  partnerList2Api = {
    list,
    select: selectItem,
    deselect: deselectItem
  };


  /* =====================
     CONFIG
  ===================== */

  window.PARTNER_FILTER_DEBUG = false;

  const SELECTORS = {
    container: '.partner-list__style_2',
    sidebar: '.find-your-match-2',
    item: '.partner-item',
    loadMoreBtn: "#load-more",
  };

  const LOAD_MORE = {
    size: 15,
    current: 1
  };
  // Section setting "Show all cards" (data-show-all="true" on the list): no 15-card paging, every card that matches the filters is shown
  if (list.dataset.showAll === 'true') LOAD_MORE.size = Infinity;

  /*
   * Location containment for the sidebar Location filter.
   * region -> its direct children (sub-regions and countries). Names must match the
   * vocabulary of the "Supported regions / countries" checkboxes in
   * sections/qikify-partner-list.liquid and the Regions / Countries lists of
   * sections/qikify-partner-sidebar.liquid. A country can sit in more than one region.
   * Matching (both directions): a card matches filter F if it ticks F, OR F is a region and
   * the card ticks anything inside F (sub-regions and countries, transitively), OR the card
   * ticks a region that contains F (transitively, e.g. EMEA -> Europe -> Germany).
   */
  const PARTNER_LOCATION_REGIONS = {
    'APAC': ['SEA', 'East Asia', 'ANZ', 'India'],
    'SEA': ['Indonesia', 'Malaysia', 'Philippines', 'Singapore', 'Thailand', 'Vietnam'],
    'East Asia': ['China', 'Hong Kong', 'Japan', 'South Korea', 'Taiwan'],
    'ANZ': ['Australia', 'New Zealand'],
    'EMEA': ['Europe', 'Middle East', 'Africa'],
    'Europe': ['Belgium', 'Denmark', 'Finland', 'France', 'Germany', 'Ireland', 'Italy', 'Netherlands', 'Norway', 'Poland', 'Spain', 'Sweden', 'Switzerland', 'United Kingdom'],
    'Middle East': ['Israel', 'United Arab Emirates'],
    'Africa': ['South Africa'],
    'North America': ['Canada', 'Mexico', 'United States'],
    'LATAM': ['Brazil', 'Mexico']
  };

  // normalized region -> Set of every normalized name inside it (transitive)
  const REGION_MEMBERS = (() => {
    const direct = {};
    Object.keys(PARTNER_LOCATION_REGIONS).forEach(region => {
      direct[normalizeText(region)] = PARTNER_LOCATION_REGIONS[region].map(normalizeText);
    });
    const members = {};
    const collect = (region, seen) => {
      (direct[region] || []).forEach(child => {
        if (seen.has(child)) return;
        seen.add(child);
        collect(child, seen);
      });
      return seen;
    };
    Object.keys(direct).forEach(region => { members[region] = collect(region, new Set()); });
    return members;
  })();

  /* =====================
     INIT
  ===================== */

  init();

  function init() {
    const container = document.querySelector(SELECTORS.container);
    const sidebar = document.querySelector(SELECTORS.sidebar);

    if (!container || !sidebar) {
      debug('Init aborted: container or sidebar not found');
      return;
    }

    // the dropdown is built by multiple-select.js on window load; after a sidebar reload in the
    // editor that already happened, so build it here (the library skips selects it already built)
    if (typeof MultiselectDropdown === 'function' && sidebar.querySelector('select[multiple]')) {
      MultiselectDropdown(window.MultiselectDropdownOptions);
    }

    const items = Array.from(container.querySelectorAll(SELECTORS.item)).filter(el => !el.hasAttribute('data-qk-filter-ghost'));

    debug('Init filter', { items: items.length });

    setupEvents(sidebar, items);

    setupLoadMore(sidebar, items);

    setupToolbar(sidebar, items);

    applyFilter(sidebar, items);
  }

  /* =====================
     HELPERS
  ===================== */

  function getMatchedItems(items, filters) {
    return items.filter(item => matchItem(item, filters));
  }

  function debug(label, data) {
    if (!window.PARTNER_FILTER_DEBUG) return;
    console.log(`[FILTER DEBUG] ${label}`, data || '');
  }

  function normalize(val = '') {
    return val.toString().trim().toLowerCase();
  }

  function normalizeText(str = '') {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeItemRange(item) {
    return {
      min: Number(item.from),
      max: item.to == null ? Number(item.from) : Number(item.to)
    };
  }
  function normalizeFilterRange(fromFilter, toFilter) {
    return {
      min: fromFilter ?? -Infinity,
      max: toFilter ?? Infinity
    };
  }

  function debounce(fn, delay = 300) {
    let t;
    const debounced = (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
    debounced.cancel = () => clearTimeout(t);
    return debounced;
  }

  /* =====================
      CORE
  ===================== */

  function renderItemsByPage(items, matchedItems, page, size) {
    // Theme Editor: no paging, so every partner can be seen, selected and highlighted
    const max = isThemeEditor() ? Infinity : page * size;
    let visibleCount = 0;

    items.forEach(item => {
      if (item === selectedItem) {
        item.style.display = 'flex';
        visibleCount++;
        return;
      }

      if (!matchedItems.includes(item)) {
        item.style.display = 'none';
        return;
      }

      if (visibleCount < max) {
        item.style.display = 'flex';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });

    return visibleCount;
  }

  function updateLoadMoreButton(btn, visible, total) {
    if (!btn) return;

    btn.style.display = !isThemeEditor() && visible < total ? 'flex' : 'none';
  }
  /* =====================
     RANGE PARSER (SAFE)
  ===================== */

  function parseRange(value = '') {
    if (!value) return { from: null, to: null };

    const str = value.toString().trim();

    if (str.includes('-')) {
      const parts = str.split('-').map(v => v.trim());
      return {
        from: parts[0] !== '' ? Number(parts[0]) : null,
        to: parts[1] !== '' ? Number(parts[1]) : null,
      };
    }

    return {
      from: Number(str),
      to: null,
    };
  }

  /* ===================== 
      SYNC FILTER URL
  ===================== */

  function syncFiltersToURL(filters) {
    const params = new URLSearchParams();

    if (filters.search) params.set('q', filters.search);
    if (filters.option1) params.set('cert', filters.option1);

    if (filters.locations?.length) {
      params.set('location', filters.locations.join(','));
    }

    if (!isNaN(filters.rangeFrom)) params.set('from', filters.rangeFrom);
    if (!isNaN(filters.rangeTo)) params.set('to', filters.rangeTo);

    if (filters.services?.length) {
      params.set('services', filters.services.join(','));
    }

    // top bar only (filters.sort is empty for the left / right sidebar): ?sort=newest|price-asc|price-desc|az|za, default order is not written
    if (filters.sort && filters.sort !== 'default') params.set('sort', filters.sort);

    const newURL =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : '');

    debug('Sync URL', newURL);

    window.history.replaceState({}, '', newURL);
  }

  function readFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    return {
      search: normalize(params.get('q') || ''),
      option1: normalize(params.get('cert') || ''),
      locations: (params.get('location') || '')
        .split(',')
        .map(normalize)
        .filter(Boolean),

      rangeFrom: params.get('from') ? Number(params.get('from')) : null,
      rangeTo: params.get('to') ? Number(params.get('to')) : null,

      services: (params.get('services') || '')
        .split(',')
        .map(normalize)
        .filter(Boolean),

      sort: normalize(params.get('sort') || ''),
    };
  }

  function applyFiltersToUI(sidebar, filters) {
    // search
    const searchInput = sidebar.querySelector('.option-list__search input');
    if (searchInput) searchInput.value = filters.search || '';

    // option1 (radio)
    if (filters.option1) {
      sidebar.querySelectorAll('.option-list__1 [data-option]').forEach(li => {
        const input = li.querySelector('input[type="radio"]');
        input.checked = normalize(li.dataset.option) === filters.option1;
      });
    }

    // price range
    const fromInput = sidebar.querySelector('.option-list__3--range-from');
    const toInput = sidebar.querySelector('.option-list__3--range-to');

    if (fromInput) fromInput.value = filters.rangeFrom ?? '';
    if (toInput) toInput.value = filters.rangeTo ?? '';

    // services (checkbox)
    sidebar
      .querySelectorAll('.option-list__4 [data-option]')
      .forEach(li => {
        const input = li.querySelector('input[type="checkbox"]');
        input.checked = filters.services.includes(normalize(li.dataset.option));
      });

    // option5 (checkbox)
    sidebar
      .querySelectorAll('.option-list__5 [data-option]')
      .forEach(li => {
        const input = li.querySelector('input[type="checkbox"]');
        input.checked = (filters.option5 || []).includes(normalize(li.dataset.option));
      });

    // sort (top bar): an unknown ?sort= value is ignored
    const sortSelect = sidebar.querySelector('.partner-toolbar__sort');
    if (sortSelect && filters.sort && Array.from(sortSelect.options).some(o => o.value === filters.sort)) sortSelect.value = filters.sort;

    // locations (dropdown): ?location=japan, ?location=united states,europe, ?location=us (abbreviation), any case, URL-encoded
    applyLocationsFromURL(sidebar, filters.locations);

    debug('UI restored from URL', filters);
  }

  /*
   * The dropdown stores the full lowercase name as option value ("united states"); a country with a displayed abbreviation also lists its
   * spellings in data-alias ("united states|us|usa|america ..."). A ?location= value matches the value or any alias, exactly (so "us" never
   * picks Australia); a value that matches nothing is ignored.
   */
  function findLocationOption(select, token) {
    const wanted = normalizeText(token);
    if (!wanted) return null;
    return Array.from(select.options).find(o => {
      const keys = [o.value].concat(((o.dataset && o.dataset.alias) || '').split('|'));
      return keys.some(k => normalizeText(k) === wanted);
    }) || null;
  }

  function applyLocationsFromURL(sidebar, locations) {
    if (!locations || !locations.length) return;
    const select = sidebar.querySelector('.option-list__2 select[multiple]');
    if (!select) return;

    const wanted = new Set();
    locations.forEach(loc => {
      const opt = findLocationOption(select, loc);
      if (opt) wanted.add(opt);
    });

    Array.from(select.options).forEach(o => { o.selected = wanted.has(o); });
    // rows, tags and aria of the dropdown follow the select (multiple-select.js); if it is not built yet it reads option.selected when it is
    if (typeof select.syncOptions === 'function') select.syncOptions();
  }

  /* =====================
     READ FILTERS
  ===================== */

  function getFilters(sidebar) {
    const filters = {};

    filters.search = normalize(sidebar.querySelector('.option-list__search input')?.value);

    filters.option1 = normalize(sidebar.querySelector('.option-list__1 input:checked')?.closest('[data-option]')?.dataset.option);

    // the option VALUE (full lowercase name), never the label: a long country name is displayed abbreviated (US, UAE, UK-GB)
    const locationSelect = sidebar.querySelector('.option-list__2 select[multiple]');
    filters.locations = locationSelect
      ? Array.from(locationSelect.selectedOptions).map(o => normalize(o.value))
      : Array.from(sidebar.querySelectorAll('.option-list__2 .multiselect-dropdown input[type="checkbox"]:checked')).map(cb => normalize(cb.nextElementSibling?.textContent));

    filters.rangeFrom = parseFloat(sidebar.querySelector('.option-list__3--range-from')?.value);
    filters.rangeTo = parseFloat(sidebar.querySelector('.option-list__3--range-to')?.value);

    filters.services = Array.from(sidebar.querySelectorAll('.option-list__4 input:checked')).map(i => normalize(i.closest('[data-option]').dataset.option));

    const sortSelect = sidebar.querySelector('.partner-toolbar__sort');
    filters.sort = sortSelect ? sortSelect.value : '';

    debug('Current filters', filters);

    return filters;
  }

  /* =====================
     MATCH LOGIC
  ===================== */

  function matchRange(item, fromFilter, toFilter) {
    const range = parseRange(item.dataset.option3);
    const itemRange = normalizeItemRange(range);
    const filterRange = normalizeFilterRange(fromFilter, toFilter);

    return !(
      itemRange.max < filterRange.min ||
      itemRange.min > filterRange.max
    );
  }

  function matchSupported(filter, supported) {
    if (supported.has(filter)) return true;

    // filter is a region: card ticks something inside it
    const inside = REGION_MEMBERS[filter];
    if (inside && Array.from(inside).some(name => supported.has(name))) return true;

    // card ticks a region that contains the filter (country or sub-region)
    return Array.from(supported).some(name => REGION_MEMBERS[name] && REGION_MEMBERS[name].has(filter));
  }

  function matchLocation(itemLocation = '', filterLocations = [], supportedLocations = '') {
    if (!filterLocations.length) return true;

    // Supported regions/countries ticked on the card ("|" separated, lowercase).
    // Region <-> country containment via REGION_MEMBERS. Cards without any
    // fall back to the legacy free-text location below.
    if (supportedLocations) {
      const supported = new Set(
        supportedLocations
          .split('|')
          .map(s => normalizeText(s))
          .filter(Boolean)
      );

      return filterLocations.some(loc => matchSupported(normalizeText(loc), supported));
    }

    const parts = normalizeText(itemLocation)
      .split(',')
      .map(s => s.trim());

    return filterLocations.some(loc =>
      parts.some(p => p.includes(normalizeText(loc)))
    );
  }

  function matchServices(itemServices = '', filterServices = []) {
    if (!filterServices.length) return true;

    const itemList = normalizeText(itemServices)
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    return filterServices.some(service =>
      itemList.some(itemService =>
        itemService.includes(normalizeText(service))
      )
    );
  }

  function matchItem(item, f) {
    debug('Checking item', item.dataset.index, f);

    if (f.search && !normalize(item.textContent).includes(f.search)) {
      debug('Search failed');
      return false;
    }

    if (f.option1 && normalize(item.dataset.option1) !== f.option1) {
      debug('Option1 failed');
      return false;
    }

    if (!matchLocation(item.dataset.option2, f.locations, item.dataset.supportedLocations)) {
      debug('Location failed');
      return false;
    }

    if (!matchRange(item, f.rangeFrom, f.rangeTo)) {
      debug('Range failed');
      return false;
    }

    if (!matchServices(item.dataset.option4, f.services)) {
      debug('Services failed');
      return false;
    }

    debug('Item passed');
    return true;
  }

  /* =====================
     APPLY FILTER
  ===================== */

  function applyFilter(sidebar, items, resetPage = true) {
    settleAnimation(); // a card that is still opening / closing jumps to its end state before the list changes
    const filters = getFilters(sidebar);

    if (resetPage) {
      LOAD_MORE.current = 1;
    }

    // top bar: the cards are matched, paged and (when the order changed) moved in the DOM in the chosen sort order; the HTML itself stays in editorial order
    const ordered = filters.sort ? sortItems(items, filters.sort) : items;

    const matchedItems = getMatchedItems(ordered, filters);

    // the one DOM change of a filter run (re-order + show / hide). On a list that opted in to the shared motion component
    // (data-qk-filter, assets/qikify-filter-anim.js; the List rows layout) it runs inside QikifyFilterAnim.update(), which adds the
    // leave / glide / enter motion around it. Everywhere else, or when the component is absent, it just runs: no change in behaviour.
    let visible = 0;
    const commit = () => {
      if (filters.sort) applySortOrder(ordered);
      visible = renderItemsByPage(
        ordered,
        matchedItems,
        LOAD_MORE.current,
        LOAD_MORE.size
      );
    };
    if (window.QikifyFilterAnim && list.hasAttribute('data-qk-filter')) window.QikifyFilterAnim.update(list, commit);
    else commit();

    const loadMoreBtn = document.querySelector(SELECTORS.loadMoreBtn);
    updateLoadMoreButton(loadMoreBtn, visible, matchedItems.length);

    syncFiltersToURL(filters);

    updateToolbar(sidebar, matchedItems.length, filters);

    debug('Visible items', {
      visible,
      total: matchedItems.length,
      page: LOAD_MORE.current
    });
  }

  function setupLoadMore(sidebar, items) {
    const btn = document.querySelector(SELECTORS.loadMoreBtn);
    if (!btn) return;

    listen(btn, 'click', () => {
      LOAD_MORE.current++;
      applyFilter(sidebar, items, false);
    });
  }

  /* =====================
     TOP BAR (sidebar position "Top bar": the same filter inputs laid out as a horizontal toolbar)
     Only does anything when the sidebar has the class sidebar--top; the left / right sidebar is untouched.
  ===================== */

  // keys: default (editorial order = data-index), newest, price-asc, price-desc, az, za. Stable: ties keep the editorial order.
  function sortItems(items, key) {
    const idx = el => Number(el.dataset.index);
    const base = items.slice().sort((a, b) => idx(a) - idx(b));
    if (!key || key === 'default') return base;
    const nameOf = el => ((el.querySelector('.partner-item__text_1') || {}).textContent || '').trim();
    const priceOf = el => {
      const n = parseFloat(String(el.dataset.price || '').replace(/[^0-9.]/g, ''));
      return isNaN(n) ? null : n;
    };
    const addedOf = el => {
      const t = Date.parse(String(el.dataset.added || '').trim());
      return isNaN(t) ? null : t;
    };
    const byName = (a, b) => nameOf(a).localeCompare(nameOf(b), undefined, { sensitivity: 'base', numeric: true });
    // a card without a price always goes last, in both price sorts
    const byPrice = dir => (a, b) => {
      const pa = priceOf(a), pb = priceOf(b);
      if (pa === null && pb === null) return idx(a) - idx(b);
      if (pa === null) return 1;
      if (pb === null) return -1;
      return dir * (pa - pb) || idx(a) - idx(b);
    };
    // dated cards first (newest first), then the undated ones, later block = newer
    const byNewest = (a, b) => {
      const da = addedOf(a), db = addedOf(b);
      if (da !== null && db !== null) return (db - da) || (idx(b) - idx(a));
      if (da !== null) return -1;
      if (db !== null) return 1;
      return idx(b) - idx(a);
    };
    const cmp = {
      az: (a, b) => byName(a, b) || idx(a) - idx(b),
      za: (a, b) => byName(b, a) || idx(a) - idx(b),
      'price-asc': byPrice(1),
      'price-desc': byPrice(-1),
      newest: byNewest
    }[key];
    return cmp ? base.sort(cmp) : base;
  }

  // moves the cards only when the DOM order differs from the wanted one (so typing in the search box does not shuffle nodes for nothing)
  function applySortOrder(ordered) {
    const current = Array.from(list.children).filter(el => el.classList.contains('partner-item') && !el.hasAttribute('data-qk-filter-ghost'));
    if (current.length === ordered.length && current.every((el, i) => el === ordered[i])) return;
    ordered.forEach(el => list.appendChild(el));
  }

  function isToolbar(sidebar) {
    return !!(sidebar && sidebar.closest && sidebar.closest('.sidebar--top'));
  }

  function clearAllFilters(sidebar) {
    const search = sidebar.querySelector('.option-list__search input');
    if (search) search.value = '';
    sidebar.querySelectorAll('.option-list__1 input[type="radio"]').forEach(i => { i.checked = false; });
    sidebar.querySelectorAll('.option-list__3--range-from, .option-list__3--range-to').forEach(i => { i.value = ''; });
    sidebar.querySelectorAll('.option-list__4 input[type="checkbox"], .option-list__5 input[type="checkbox"]').forEach(i => { i.checked = false; });
    const select = sidebar.querySelector('.option-list__2 select[multiple]');
    if (select) {
      Array.from(select.options).forEach(o => { o.selected = false; });
      if (typeof select.syncOptions === 'function') select.syncOptions();
    }
  }

  // result count, "Clear all", the number of active filters on the Filters button and on each services popover
  function updateToolbar(sidebar, matched, filters) {
    if (!isToolbar(sidebar)) return;
    const count = sidebar.querySelector('.partner-toolbar__count');
    /* texts: data-i18n-* attributes on .partner-toolbar__status (sections/qikify-partner-sidebar.liquid, locales general_agency_directory.*); {number} is filled in here */
    const say = (key, vars) => String((sidebar.querySelector('.partner-toolbar__status') || { getAttribute: () => '' }).getAttribute('data-i18n-' + key) || '').replace(/\{(\w+)\}/g, (m, k) => (vars && Object.prototype.hasOwnProperty.call(vars, k)) ? String(vars[k]) : m);
    if (count) count.textContent = matched === 0 ? say('count-none') : say(matched === 1 ? 'count-one' : 'count-other', { number: matched });

    const active = (filters.search ? 1 : 0) + (filters.option1 ? 1 : 0) + (filters.locations && filters.locations.length ? 1 : 0)
      + ((!isNaN(filters.rangeFrom) || !isNaN(filters.rangeTo)) ? 1 : 0) + (filters.services && filters.services.length ? 1 : 0);
    const clear = sidebar.querySelector('.partner-toolbar__clear');
    if (clear) clear.hidden = active === 0;
    const badge = sidebar.querySelector('.partner-toolbar__toggle-badge');
    if (badge) { badge.textContent = String(active); badge.hidden = active === 0; }

    // number of choices made inside each popover (price counts once, whether From, Up to or both are filled)
    sidebar.querySelectorAll('details.option-list__pop').forEach(pop => {
      let n = pop.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
      n += Array.from(pop.querySelectorAll('input[type="text"]')).filter(i => i.value.trim() !== '').length;
      if (pop.closest('.option-list__3')) n = Math.min(n, 1);
      const c = pop.querySelector('.option-list__pop-count');
      if (c) { c.textContent = String(n); c.hidden = n === 0; }
    });
  }

  function setupToolbar(sidebar, items) {
    if (!isToolbar(sidebar)) return;

    // phones: the fields sit behind the Filters button
    const toggle = sidebar.querySelector('.partner-toolbar__toggle');
    if (toggle) {
      listen(toggle, 'click', () => {
        const open = !sidebar.classList.contains('is-open');
        sidebar.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // announce a new sort order to screen readers (the result count is announced by its own live region)
    const sortSelect = sidebar.querySelector('.partner-toolbar__sort');
    const sortNote = sidebar.querySelector('.partner-toolbar__sort-note');
    if (sortSelect && sortNote) {
      listen(sortSelect, 'change', () => {
        const opt = sortSelect.options[sortSelect.selectedIndex];
        const note = sidebar.querySelector('.partner-toolbar__status');
        const tpl = (note && note.getAttribute('data-i18n-sorted-by')) || '';
        sortNote.textContent = opt ? tpl.replace(/\{sort\}/g, () => opt.text) : '';
      });
    }

    // "Clear all" resets the filters (search, certification, locations, price, services) and keeps the chosen sort: the sort is a view choice, not a filter
    const clear = sidebar.querySelector('.partner-toolbar__clear');
    if (clear) {
      listen(clear, 'click', () => {
        clearAllFilters(sidebar);
        applyFilter(sidebar, items);
      });
    }

    // services (and option 5) popovers: one open at a time, close on an outside click or Esc
    const pops = Array.from(sidebar.querySelectorAll('details.option-list__pop'));
    pops.forEach(pop => {
      listen(pop, 'toggle', () => {
        if (pop.open) pops.forEach(other => { if (other !== pop) other.open = false; });
      });
    });
    listen(document, 'click', (e) => {
      pops.forEach(pop => { if (pop.open && !pop.contains(e.target)) pop.open = false; });
    });
    listen(sidebar, 'keydown', (e) => {
      if (e.key !== 'Escape') return;
      const pop = pops.find(p => p.open);
      if (!pop) return;
      pop.open = false;
      const summary = pop.querySelector('summary');
      if (summary) summary.focus();
    });
  }

  /* =====================
     EVENTS
  ===================== */

  function setupEvents(sidebar, items) {
    const onInput = debounce(() => applyFilter(sidebar, items), 300);
    listen(sidebar, 'input', onInput);
    cleanups.push(() => onInput.cancel && onInput.cancel());

    listen(sidebar, 'change', () => {
      applyFilter(sidebar, items)
    });

    // option1 (radio): click the selected option again to clear it
    sidebar.querySelectorAll('.option-list__1 input[type="radio"]').forEach(input => {
      let wasChecked = false;

      listen(input.closest('label'), 'pointerdown', () => {
        wasChecked = input.checked;
      });

      listen(input, 'click', () => {
        if (wasChecked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        wasChecked = false;
      });
    });

    const urlFilters = readFiltersFromURL();
    // The URL holds the filters of the previous render. On a re-init (Theme Editor section reload)
    // its location list must not be re-applied: it would override what the visitor clicks next.
    if (partnerList2Booted) urlFilters.locations = [];
    partnerList2Booted = true;
    applyFiltersToUI(sidebar, urlFilters);

    // (the ?location= list is applied once, above; re-applying it here would undo what the visitor picks next)
    listen(document, 'multiselect:option-change', (e) => {
      applyFilter(sidebar, items);
    });
  }
}

/*
**
** PARTNER DIRECTORY 2 - END
**
*/

/*
**
** CASE STUDY - START
**
*/
const loadArticleByFilterTags = (url, list_tag) => {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url + '/tagged/' + list_tag + '?view=ajax_filter', true);

  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        var blogContainer = document.querySelector('.blog-case-study-container .blog-articles');
        if (blogContainer) {
          blogContainer.innerHTML = xhr.responseText;
        } else {
          console.log('container not found!');
        }
      } else {
        console.log('Request failed. Returned status of ' + xhr.status);
      }
    }
  };

  xhr.send();
}

const initBlogCaseStudy = () => {
  var filterBlock = document.querySelector('.blog-select-group[data-filter-block]');
  if (filterBlock) {
    var url = filterBlock.getAttribute('data-blog');

    document.querySelectorAll(".tag-select-box").forEach(function (selectBox) {
      selectBox.addEventListener('change', function () {
        var list_tag = "";
        document.querySelectorAll(".tag-select-box").forEach(function (selectBox, index) {
          // var formattedValue = selectBox.value.toLowerCase()
          var formattedValue = selectBox.value.toLowerCase().replace(/ /g, "-").replace(/&/g, "").replace(/-+/g, "-");
          list_tag += formattedValue;
          if (index != 2) list_tag += '+';
        });

        loadArticleByFilterTags(url, list_tag);
      });
    });
  }
}

window.onload = function () {
  if (document.body.hasAttribute('template-case-study')) {
    initBlogCaseStudy();
  }
}

/*
**
** CASE STUDY - END 
**
*/

/*
**
** PROGRAM INFORMATION - START
**
*/
const initProgramOptions = () => {
  const allSections = document.querySelectorAll('.slide-heading-tab');

  if (allSections.length == 0) return;

  allSections.forEach(section => {
    const tabs = section.querySelectorAll('.tab');
    const contents = section.nextElementSibling?.querySelectorAll('.content') ? section.nextElementSibling?.querySelectorAll('.content') : section.querySelectorAll('.content');

    function activateTab(tabId) {
      tabs.forEach(tab => tab.classList.remove('active'));
      contents.forEach(content => content.classList.remove('active'));
      section.querySelector(`#program-options-tab-${tabId}`).classList.add('active');
      section.nextElementSibling?.querySelector(`#program-options-content-${tabId}`) ? section.nextElementSibling?.querySelector(`#program-options-content-${tabId}`).classList.add('active') : section.querySelector(`#program-options-content-${tabId}`).classList.add('active');
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateTab(index + 1);
      });
    });
  });
}
/*
**
** PROGRAM INFORMATION - END 
**
*/

/*
**
** BRAND MAP - START
**
*/
const initBrandMap = () => {
  const allSections = document.querySelectorAll('.section-qikify-brand-map');
  if (allSections && allSections.length > 0) {
    allSections.forEach(section => {
      const items = section.querySelectorAll('.brand-map__item');
      const totalItems = items.length;
      const visibleCount = 3;

      if (Shopify.designMode) {
        items.forEach(item => {
          const icon = item.querySelector('.brand-map__icon');
          const img = item.querySelector('.brand-map__image');

          icon.style.opacity = 0;
          img.style.opacity = 0;
          img.style.transform = 'translateY(20px)'
        });
      }

      const getRandomIndex = (exclude) => {
        const availableIndices = [...Array(totalItems).keys()].filter(i => !exclude.includes(i));
        return availableIndices[Math.floor(Math.random() * availableIndices.length)];
      };

      const showItems = () => {
        let currentIndices = [];
        while (currentIndices.length < visibleCount) {
          const randomIndex = getRandomIndex(currentIndices);
          currentIndices.push(randomIndex);
        }

        currentIndices.forEach((index) => {
          const item = items[index];
          const icon = item.querySelector('.brand-map__icon');
          const img = item.querySelector('.brand-map__image');

          if (Shopify.designMode) {
            item.style.opacity = 1;
            icon.style.opacity = 0.5;
            img.style.opacity = 1;
            img.style.transform = 'translateY(0)';
          } else {
            item.classList.add('visible');
            icon.classList.add('fadeIn');
            img.classList.add('fadeInUp');
          }

        });

        setInterval(() => {
          const currentIndex = getRandomIndex(currentIndices);
          const indexToHide = currentIndices.shift();
          const itemToHide = items[indexToHide];
          const iconToHide = itemToHide.querySelector('.brand-map__icon');
          const imgToHide = itemToHide.querySelector('.brand-map__image');

          setTimeout(() => {
            if (Shopify.designMode) {
              itemToHide.style.opacity = 0;
              iconToHide.style.opacity = 0;
              imgToHide.style.opacity = 0;
              imgToHide.style.transform = 'translateY(20px)';
            } else {
              itemToHide.classList.remove('visible');
              iconToHide.classList.remove('fadeIn');
              imgToHide.classList.remove('fadeInUp');
            }
          }, 500)

          currentIndices.push(currentIndex);

          const newItem = items[currentIndex];
          const newIcon = newItem.querySelector('.brand-map__icon');
          const newImg = newItem.querySelector('.brand-map__image');
          if (Shopify.designMode) {
            newItem.style.opacity = 1;
            newIcon.style.opacity = 0.5;
            newImg.style.opacity = 1;
            newImg.style.transform = 'translateY(0)';
          } else {
            newItem.classList.add('visible');
            newIcon.classList.add('fadeIn');
            newImg.classList.add('fadeInUp');
          }

        }, 4000);
      }

      showItems();
    })
  }
}

/*
**
** BRAND MAP - END
**
*/

const initIndustryShowcase = () => {
  const scrollers = document.querySelectorAll(".section-qikify-industry-showcase .scroller");
  if (scrollers) {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      scrollers.forEach(scroller => {
        scroller.setAttribute("data-animated", true);

        const scrollerInner = scroller.querySelector(".scroller__inner");
        const scrollerContent = Array.from(scrollerInner.children);

        scrollerContent.forEach(item => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    }
  }

  const listItems = document.querySelectorAll('.section-qikify-industry-showcase .industry-showcase__slider--text-item');
  if (listItems) {
    listItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        const title = item.getAttribute('data-title');
        document.querySelectorAll(`[data-title="${title}"]`).forEach(el => {
          el.classList.add('hover');
        });
      });
      item.addEventListener('mouseleave', () => {
        const title = item.getAttribute('data-title');
        document.querySelectorAll(`[data-title="${title}"]`).forEach(el => {
          el.classList.remove('hover');
        });
      });
    });
  }
}

/* Init WOW.js animation */

const initWOW = () => {
  var wow = new WOW({
    boxClass: 'wow',      // animated element css class (default is wow)
    animateClass: 'animated', // animation css class (default is animated)
    offset: -100,          // distance to the element when triggering the animation (default is 0)
    mobile: true,       // trigger animations on mobile devices (default is true)
    live: true,       // act on asynchronously loaded content (default is true)
    callback: function (box) {
      // the callback is fired every time an animation is started
      // the argument that is passed in is the DOM node being animated
    },
    scrollContainer: null,    // optional scroll container selector, otherwise use window,
    resetAnimation: true,     // reset animation on end (default is true)
  }
  );
  wow.init();
}

const initCopyToClipboard = () => {
  const elements = document.querySelectorAll('a.x-button, div[class*="code-"]');
  if (elements.length > 0) {
    elements.forEach(el => {
      const classList = el.classList;
      el.style.cursor = "pointer";
      const codeClass = [...classList].find(cls => cls.startsWith('code-'));

      if (codeClass) {
        let codeText = codeClass.replace('code-', '');

        const match = codeText.match(/^\[(.*)\]$/);
        if (match) {
          codeText = match[1];
        }

        el.addEventListener('click', () => {
          navigator.clipboard.writeText(codeText).then(() => {
            console.log(`Copied: ${codeText}`);
            alert(`Copied: ${codeText}`);
          }).catch(err => {
            console.error('Failed to copy text: ', err);
          });
        });
      }
    });
  }
}

/**/

const initHeaderStickyHeight = () => {
  var getPromoBar = document.querySelectorAll('.qsk-promobar__single-bar');
  if (getPromoBar.length > 0) {
    getPromoBar.forEach((bar) => {
      var height = bar.offsetHeight;
      var stickyHeader = document.querySelector('.section-qikify-header');
      if (stickyHeader) {
        stickyHeader.style = `--qsb-height: ${height}px`;
      }
    })
  }
}

/**/

/* Shopify Privacy policy page - START */
const initPrivacyPolicyPage = () => {
  if (window.location.pathname === "/policies/privacy-policy" || window.location.pathname === "/policies/terms-of-service") {
    document.body.classList.add("template-privacy-policy");

    const floatingImageDiv = document.createElement("div");
    floatingImageDiv.className = "main-page-header__floatingimage";
    floatingImageDiv.innerHTML = `
      <img src="//qikify.com/cdn/shop/files/background-image_15cb4a08-1a96-4d8e-b440-63400b3668e1.png?v=1725956843" alt="" width="1686" height="1193">
    `;

    const policyTitleEl = document.querySelector(".shopify-policy__container .shopify-policy__title");
    if (policyTitleEl) {
      policyTitleEl.appendChild(floatingImageDiv);
    }
  }
}
/* Shopify Privacy policy page - END */

/* Testimonial slider - START */
const initTestimonialSlider = () => {
  const sliders = document.querySelectorAll('.data-slider-testimonial');

  if (sliders.length == 0) return;

  sliders.forEach(slider => {
    const prevNext = slider.getAttribute('data-prevnext') === 'true';
    const groupCells = slider.getAttribute('data-groupcells');
    const adaptiveHeight = slider.getAttribute('data-adaptiveHeight') === 'true';
    let autoplay = slider.getAttribute('data-autoplay') === 'true';
    const autospeed = slider.getAttribute('data-autospeed');
    if (autoplay && parseInt(autospeed) != 3000) {
      autoplay = parseInt(autospeed)
    }
    const fadetransition = slider.getAttribute('data-fadetransition') === 'true';

    const flkty = new Flickity(slider, {
      cellAlign: 'center',
      wrapAround: true,
      adaptiveHeight: adaptiveHeight,
      autoPlay: autoplay,
      pauseAutoPlayOnHover: false,
      // contain: true,
      fade: fadetransition,
      imagesLoaded: true,
      lazyLoad: true,
      // freeScroll: true,
      on: {
        ready: function () {
          const prevBtn = slider.querySelector('.flickity-button.previous');
          const nextBtn = slider.querySelector('.flickity-button.next');
          if (prevBtn) {
            prevBtn.querySelector('.flickity-button-icon').outerHTML = `<svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7923 2.585L11.2073 0L0.207275 11L11.2073 22L13.7923 19.415L5.39561 11L13.7923 2.585Z" fill="white"/></svg>`;
          }
          if (nextBtn) {
            nextBtn.querySelector('.flickity-button-icon').outerHTML = `<svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.79252 0L0.20752 2.585L8.60419 11L0.20752 19.415L2.79252 22L13.7925 11L2.79252 0Z" fill="white"/></svg>`;
          }

          const buttonsWrapper = slider.closest('.testimonial__wrapper')?.querySelector('.testimonial__buttons');
          if (buttonsWrapper) {
            buttonsWrapper.appendChild(prevBtn);
            buttonsWrapper.appendChild(nextBtn);
          }
        },
        select: function (index) {
          const cells = this.getCellElements();
          cells.forEach(cell => {
            cell.classList.remove('is-prev', 'is-next');
          });

          const prevIndex = (index - 1 + cells.length) % cells.length;
          const nextIndex = (index + 1) % cells.length;

          cells[prevIndex].classList.add('is-prev');
          cells[nextIndex].classList.add('is-next');
        },
        change: function (index) { },
        settle: function (index) { }
      }
    });
  });
}
/* Testimonial slider - END */

/* USP - Tab Navigation - START */
const initUSPTabNavigation = () => {
  const allSections = document.querySelectorAll('.section-qikify-usp [data-tab-navigation]');
  if (allSections.length == 0) return;

  allSections.forEach(section => {
    const tabs = section.querySelectorAll('.image-with-text__text-item .usp__icon-with-text');
    const imagesWrapper = section.querySelectorAll('.image-with-text__media-item .image-with-text__media');

    function activateTab(index) {
      tabs.forEach(tab => tab.classList.remove('active'));
      imagesWrapper.forEach(img => {
        img.classList.remove('active')
        const images = img.querySelectorAll('img.wow');
        images.forEach(image => {
          image.style.visibility = 'hidden';
          image.style.animationName = 'none';
          image.classList.remove('animated');
        })
      });

      const tab = tabs[index];
      const image = imagesWrapper[index];
      if (tab) tab.classList.add('active');
      if (image) {
        const images = image.querySelectorAll('img.wow');
        images.forEach(image => {
          image.style.visibility = 'visible';
          image.style.animationName = 'fadeInUp';
          image.classList.add('animated');
        })
        image.classList.add('active');
      }
      window.dispatchEvent(new CustomEvent('resize'));

      const content = tab.querySelector('.usp__icon-with-text--content-2');
      tabs.forEach(t => {
        const c = t.querySelector('.usp__icon-with-text--content-2');
        if (c) c.style.maxHeight = '0';
      });
      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    tabs.forEach((tab, index) => {
      const title = tab.querySelector('.usp__icon-with-text--title');
      (tab || title).addEventListener('click', () => {
        activateTab(index);
        if (autoplayInterval) {
          startAutoplay(); // Reset timer on manual click
        }
      });
    });

    let autoplayInterval;
    const autoplayDuration = parseFloat(section.getAttribute('data-autoplay')) * 1000;

    function startAutoplay() {
      if (!autoplayDuration) return;
      clearInterval(autoplayInterval);
      autoplayInterval = setInterval(() => {
        let currentIndex = Array.from(tabs).indexOf(section.querySelector('.usp__icon-with-text.active'));
        let nextIndex = (currentIndex + 1) % tabs.length;
        activateTab(nextIndex);
      }, autoplayDuration);
    }

    if (autoplayDuration) {
      startAutoplay();
    }

    if (tabs.length) activateTab(0);
  })
}
/* USP - Tab Navigation - END */

/* init func */

const init = () => {
  $(window).scroll(() => {
    if (document.body.classList.contains('template-article')) {
      initScrollIndicator();
    }
  })
  initCopyToClipboard();
  initActiveHeadingWhenScrolling();
  document.addEventListener("DOMContentLoaded", () => {
    initSlider();
    initIndustryShowcase();
    initWOW();
    initHeaderStickyHeight();
    initTestimonialSlider();
    initUSPTabNavigation();
  })

  initProgramOptions();
  // Only the old style 1 markup has #partner-container; the rebuilt tech directory (qtd- sections) does not, and initPartnerList would throw on it and stop the rest of init()
  if (document.body.hasAttribute('template-partner-directory') && document.getElementById('partner-container')) {
    initPartnerList();
    initGetUrlParameter();
  }
  if (document.querySelector('.partner-list__style_2')) {
    if (document.readyState === 'loading') {
      document.addEventListener("DOMContentLoaded", () => {
        initPartnerList2();
      });
    } else {
      initPartnerList2();
    }
  }
  // Theme Editor (registered once; they do nothing on pages without a style 2 list or its sidebar)
  const isPartnerList2Section = (el) => !!(el && el.querySelector && el.querySelector('.partner-list__style_2, .find-your-match-2'));
  document.addEventListener('shopify:section:load', (e) => {
    if (isPartnerList2Section(e.target)) initPartnerList2();
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (isPartnerList2Section(e.target)) teardownPartnerList2();
  });
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target && e.target.closest && e.target.closest('.partner-list__style_2 .partner-item');
    if (item && partnerList2Api) partnerList2Api.select(item);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const item = e.target && e.target.closest && e.target.closest('.partner-list__style_2 .partner-item');
    if (item && partnerList2Api) partnerList2Api.deselect(item);
  });
  initBrandMap();
  if (window.location.pathname.includes("how-to-use-discounts")) {
    document.querySelectorAll('a').forEach(link => {
      if (link.textContent.trim() === "WholeWoodPlayhouses" || link.textContent.trim() === "Whey Protein Powder") {
        link.removeAttribute("rel");
      }
    });
  }
  initPrivacyPolicyPage();
};

init();